// import React, { useEffect, useRef, useState } from "react";
// import { createPortal } from "react-dom";
// import toast from "react-hot-toast";
// import api from "../chat/api";

// const FeedbackPopup = ({
//   isOpen,
//   onClose,
//   messageId,
//   feedbackType = "down",
//   messageMeta,
// }) => {
//   const popupRef = useRef(null);

//   const [positionStyle, setPositionStyle] = useState({
//     bottom: "100%",
//     marginBottom: "8px",
//   });

//   const [showModal, setShowModal] = useState(false);
//   const [feedbackText, setFeedbackText] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Tracks if feedback has already been sent to prevent duplicate API calls
//   const hasSubmittedRef = useRef(false);

//   // Track latest props for the unmount cleanup and beacon to avoid stale closures
//   const activeMetaRef = useRef({ messageMeta, feedbackType });
//   useEffect(() => {
//     activeMetaRef.current = { messageMeta, feedbackType };
//   }, [messageMeta, feedbackType]);

//   const submitFeedbackData = async (text = "") => {
//     const { messageMeta: currentMeta, feedbackType: currentType } =
//       activeMetaRef.current;

//     if (!currentMeta || hasSubmittedRef.current) return;
//     hasSubmittedRef.current = true; // Lock immediately

//     try {
//       await api.post("/api/v1/rfp/feedback/", {
//         message_id: currentMeta.django_message_id,
//         feedback_type: currentType,
//         run_id: currentMeta.run_id,
//         user_feedback:
//           text.trim() ||
//           (currentType === "up" ? "Good response" : "Bad response"),
//       });

//       toast.success("Thanks for your feedback!", {
//         position: "bottom-right",
//         duration: 2000,
//         style: {
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     } catch (error) {
//       console.error("Error submitting feedback:", error);
//       toast.error("Failed to submit feedback.", {
//         position: "bottom-right",
//         duration: 3000,
//         style: {
//           background: "#1a1a1a",
//           color: "#fff",
//           borderRadius: "10px",
//           fontSize: "14px",
//         },
//       });
//     }
//   };

//   // EDGE CASE 1 & 2: Cleanup on unmount or forced close (e.g., new message sent)
//   useEffect(() => {
//     return () => {
//       if (!hasSubmittedRef.current && isOpen) {
//         submitFeedbackData("");
//       }
//     };
//   }, [isOpen]);

//   // EDGE CASE 3: User closes the browser tab entirely while popup is open
//   useEffect(() => {
//     const handleTabClose = () => {
//       const { messageMeta: currentMeta, feedbackType: currentType } =
//         activeMetaRef.current;
//       if (isOpen && !hasSubmittedRef.current && currentMeta) {
//         const payload = JSON.stringify({
//           message_id: currentMeta.django_message_id,
//           feedback_type: currentType,
//           run_id: currentMeta.run_id,
//           user_feedback:
//             currentType === "up" ? "Good response" : "Bad response",
//         });
//         const blob = new Blob([payload], { type: "application/json" });
//         navigator.sendBeacon("/api/v1/rfp/feedback/", blob);
//       }
//     };

//     window.addEventListener("beforeunload", handleTabClose);
//     return () => window.removeEventListener("beforeunload", handleTabClose);
//   }, [isOpen]);

//   // Reset state when popup closes
//   useEffect(() => {
//     if (!isOpen) {
//       setShowModal(false);
//       setFeedbackText("");
//       setIsSubmitting(false);
//       hasSubmittedRef.current = false;
//     }
//   }, [isOpen]);

//   // Positioning for inline popup
//   useEffect(() => {
//     if (!isOpen || !popupRef.current || showModal) return;

//     const popupRect = popupRef.current.getBoundingClientRect();
//     const scrollContainer = popupRef.current.closest(".overflow-y-auto");

//     if (scrollContainer) {
//       const containerRect = scrollContainer.getBoundingClientRect();
//       if (popupRect.top < containerRect.top) {
//         setPositionStyle({ top: "100%", marginTop: "8px" });
//       } else {
//         setPositionStyle({ bottom: "100%", marginBottom: "8px" });
//       }
//     }
//   }, [isOpen, showModal]);

//   // Click outside listener
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showModal) return;
//       const btnContainer = document.getElementById(
//         `feedback-btns-${messageId}`,
//       );
//       if (
//         popupRef.current &&
//         !popupRef.current.contains(event.target) &&
//         !(btnContainer && btnContainer.contains(event.target))
//       ) {
//         onClose();
//       }
//     };

//     if (isOpen && !showModal) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isOpen, onClose, messageId, showModal]);

//   const handleModalClose = async () => {
//     if (isSubmitting) return;

//     if (!feedbackText.trim()) {
//       await submitFeedbackData("");
//     }

//     onClose();
//   };

//   const handleModalSubmit = async () => {
//     if (!feedbackText.trim() || isSubmitting) return;

//     setIsSubmitting(true);
//     await submitFeedbackData(feedbackText);
//     setIsSubmitting(false);
//     onClose();
//   };

//   const handleModalCancel = () => {
//     submitFeedbackData("");
//     onClose();
//   };

//   if (!isOpen) return null;

//   const isThumbsUp = feedbackType === "up";

//   // MODAL VIEW (Centered)
//   if (showModal) {
//     return createPortal(
//       <div className="fixed inset-0 bg-black/40 z-[9999] font-outfit flex items-center justify-center p-4 font-outfit">
//         <div className="bg-white rounded-2xl shadow-xl w-full max-w-[500px] px-6 py-4 relative animate-in fade-in zoom-in-95 duration-200">
//           <div className="flex justify-between items-center mb-2">
//             <h2 className="text-[22px] font-semibold text-[#3F3F46] text-center w-full m-0">
//               {isThumbsUp ? "What worked well?" : "Help us improve!"}
//             </h2>
//             <button
//               onClick={handleModalClose}
//               className="absolute right-6 top-6 text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-none p-0 cursor-pointer"
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
//   <path d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956908 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25856C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956908 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956908 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25856 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956908 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25856C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25856 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z" fill="#18181B"/>
// </svg>
//             </button>
//           </div>

//           <p className="text-[14px] text-[#52525B] font-medium mt-4 mb-2">
//             {isThumbsUp
//               ? "Tell us what you liked about this response. (Optional)"
//               : "Tell us what went wrong with this response?"}
//           </p>

//           <textarea
//             value={feedbackText}
//             onChange={(e) => setFeedbackText(e.target.value)}
//             placeholder={
//               isThumbsUp
//                 ? ""
//                 : "Incorrect answer, confusing explanation, missing details, etc."
//             }
//             className="w-full border border-[#D4D4D8] rounded-xl p-3 min-h-[140px] text-[14px] text-[#3F3F46] focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] resize-none custom-scrollbar overflow-y-auto"
//           />

//           <p className="text-[13px] font-normal text-[#000000B3]  mb-6">
//             Your feedback helps improve future responses.
//           </p>

//           <div className="flex justify-center gap-4">
//             <button
//               onClick={handleModalClose}
//               disabled={isSubmitting}
//               className="px-6 py-2.5 rounded-lg border border-[#A04A97] text-[#A04A97] font-medium text-[14px] hover:bg-pink-50 transition-colors cursor-pointer bg-white disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               disabled={!feedbackText.trim() || isSubmitting}
//               onClick={handleModalSubmit}
//               className={`px-4 py-2 rounded-lg font-medium text-[14px] transition-colors border-none min-w-[120px] ${
//                 !feedbackText.trim() || isSubmitting
//                   ? "bg-[#E5C1DD] text-white cursor-not-allowed"
//                   : "bg-[#C95EBE] hover:bg-[#8e4286] text-white cursor-pointer"
//               }`}
//             >
//               {isSubmitting
//                 ? isThumbsUp
//                   ? "Sending..."
//                   : "Submitting..."
//                 : isThumbsUp
//                   ? "Send"
//                   : "Submit Feedback"}
//             </button>
//           </div>
//         </div>
//       </div>,
//       document.body,
//     );
//   }

//   // INLINE POPUP VIEW
//   return (
//     <div
//       ref={popupRef}
//       style={positionStyle}
//       className="absolute left-0 bg-white rounded-xl border border-black/20 shadow-[9px_58px_23px_0_rgba(0,0,0,0.01),1px_4px_18.9px_0_rgba(0,0,0,0.10)] p-3 min-w-[280px] font-outfit animate-in fade-in zoom-in-95 duration-200 z-[99]"
//     >
//       <div className="flex justify-between items-center mb-3">
//         <h3 className="text-gray-900 font-medium text-base m-0">
//           Thanks for your feedback!
//         </h3>
//         <button
//           onClick={onClose}
//           className="text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-none p-0 cursor-pointer"
//         >
//           <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
//   <path d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956908 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25856C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956908 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956908 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25856 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956908 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25856C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25856 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z" fill="#18181B"/>
// </svg>
//         </button>
//       </div>
//       <button
//         className="bg-[#C95EBE] border-none hover:bg-[#b052a5] text-white px-4 py-2 rounded-lg text-[14px] font-medium transition-colors cursor-pointer"
//         onClick={() => setShowModal(true)}
//       >
//         Add Comment
//       </button>
//     </div>
//   );
// };

// export default FeedbackPopup;

import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import toast from "react-hot-toast";
import api from "../chat/api";

const FeedbackPopup = ({
  isOpen,
  onClose,
  messageId,
  feedbackType = "down",
  messageMeta,
}) => {
  const popupRef = useRef(null);

  const [positionStyle, setPositionStyle] = useState({
    bottom: "100%",
    marginBottom: "8px",
  });

  const [showModal, setShowModal] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const hasSubmittedRef = useRef(false);

  const activeMetaRef = useRef({ messageMeta, feedbackType });
  useEffect(() => {
    activeMetaRef.current = { messageMeta, feedbackType };
  }, [messageMeta, feedbackType]);

  const submitFeedbackData = async (text = "") => {
    const { messageMeta: currentMeta, feedbackType: currentType } =
      activeMetaRef.current;

    if (!currentMeta || hasSubmittedRef.current) return;
    hasSubmittedRef.current = true;

    try {
      await api.post("/api/v1/rfp/feedback/", {
        message_id: currentMeta.django_message_id,
        feedback_type: currentType,
        run_id: currentMeta.run_id,
        user_feedback:
          text.trim() ||
          (currentType === "up" ? "Good response" : "Bad response"),
      });

      toast.success("Thanks for your feedback!", {
        position: "bottom-right",
        duration: 2000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback.", {
        position: "bottom-right",
        duration: 3000,
        style: {
          background: "#1a1a1a",
          color: "#fff",
          borderRadius: "10px",
          fontSize: "14px",
        },
      });
    }
  };

  useEffect(() => {
    return () => {
      if (!hasSubmittedRef.current && isOpen) {
        submitFeedbackData("");
      }
    };
  }, [isOpen]);

  useEffect(() => {
    const handlePageHide = () => {
      const { messageMeta: currentMeta, feedbackType: currentType } =
        activeMetaRef.current;

      if (isOpen && !hasSubmittedRef.current && currentMeta) {
        const payload = JSON.stringify({
          message_id: currentMeta.django_message_id,
          feedback_type: currentType,
          run_id: currentMeta.run_id,
          user_feedback: currentType === "up" ? "Good response" : "Bad response",
        });
        const blob = new Blob([payload], { type: "application/json" });
        navigator.sendBeacon("/api/v1/rfp/feedback/", blob);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        handlePageHide();
      }
    };

    window.addEventListener("pagehide", handlePageHide);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pagehide", handlePageHide);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setShowModal(false);
      setFeedbackText("");
      setIsSubmitting(false);
      hasSubmittedRef.current = false;
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || !popupRef.current || showModal) return;

    const popupRect = popupRef.current.getBoundingClientRect();
    const scrollContainer = popupRef.current.closest(".overflow-y-auto");

    if (scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      if (popupRect.top < containerRect.top) {
        setPositionStyle({ top: "100%", marginTop: "8px" });
      } else {
        setPositionStyle({ bottom: "100%", marginBottom: "8px" });
      }
    }
  }, [isOpen, showModal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showModal) return;
      const btnContainer = document.getElementById(
        `feedback-btns-${messageId}`
      );
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !(btnContainer && btnContainer.contains(event.target))
      ) {
        onClose();
      }
    };

    if (isOpen && !showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose, messageId, showModal]);

  const handleModalClose = async () => {
    if (isSubmitting) return;

    if (!feedbackText.trim()) {
      await submitFeedbackData("");
    }

    onClose();
  };

  const handleModalSubmit = async () => {
    if (!feedbackText.trim() || isSubmitting) return;

    setIsSubmitting(true);
    await submitFeedbackData(feedbackText);
    setIsSubmitting(false);
    onClose();
  };

  if (!isOpen) return null;

  const isThumbsUp = feedbackType === "up";

  if (showModal) {
    return createPortal(
      <div className="fixed inset-0 bg-black/40 z-[9999] font-outfit flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl w-full max-w-[500px] px-6 py-4 relative animate-in fade-in zoom-in-95 duration-200">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-[22px] font-semibold text-[#3F3F46] text-center w-full m-0">
              {isThumbsUp ? "What worked well?" : "Help us improve!"}
            </h2>
            <button
              onClick={handleModalClose}
              className="absolute right-6 top-6 text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-none p-0 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956908 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25856C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956908 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956908 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25856 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956908 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25856C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25856 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z"
                  fill="#18181B"
                />
              </svg>
            </button>
          </div>

          <p className="text-[14px] text-[#52525B] font-medium mt-4 mb-2">
            {isThumbsUp
              ? "Tell us what you liked about this response. (Optional)"
              : "Tell us what went wrong with this response?"}
          </p>

          <textarea
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder={
              isThumbsUp
                ? ""
                : "Incorrect answer, confusing explanation, missing details, etc."
            }
            className="w-full border border-[#D4D4D8] rounded-xl p-3 min-h-[140px] text-[14px] text-[#3F3F46] placeholder:font-normal focus:outline-none focus:border-[#C95EBE] focus:ring-1 focus:ring-[#C95EBE] resize-none custom-scrollbar overflow-y-auto"
          />

          <p className="text-[13px] font-normal text-[#000000B3] mb-6">
            Your feedback helps improve future responses.
          </p>

          <div className="flex justify-center gap-4">
            <button
              onClick={handleModalClose}
              disabled={isSubmitting}
              className="px-4 py-2 rounded-lg border border-[#A04A97] text-[#A04A97] font-medium text-[14px] hover:bg-pink-50 transition-colors cursor-pointer bg-white disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              disabled={!feedbackText.trim() || isSubmitting}
              onClick={handleModalSubmit}
              className={`px-4 py-2 rounded-lg font-medium text-[14px] transition-colors border-none min-w-[120px] ${
                !feedbackText.trim() || isSubmitting
                  ? "bg-[#E5C1DD] text-white cursor-not-allowed"
                  : "bg-[#C95EBE] hover:bg-[#8e4286] text-white cursor-pointer"
              }`}
            >
              {isSubmitting
                ? isThumbsUp
                  ? "Sending..."
                  : "Submitting..."
                : isThumbsUp
                ? "Send"
                : "Submit Feedback"}
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  return (
    <div
      ref={popupRef}
      style={positionStyle}
      className="absolute left-0 bg-white rounded-xl border border-black/20 shadow-[9px_58px_23px_0_rgba(0,0,0,0.01),1px_4px_18.9px_0_rgba(0,0,0,0.10)] p-3 min-w-[280px] font-outfit animate-in fade-in zoom-in-95 duration-200 z-[99]"
    >
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-gray-900 font-medium text-base m-0">
          Thanks for your feedback!
        </h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-none p-0 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
          >
            <path
              d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956908 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25856C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956908 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956908 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25856 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956908 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25856C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25856 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z"
              fill="#18181B"
            />
          </svg>
        </button>
      </div>
      <button
        className="bg-[#C95EBE] border-none hover:bg-[#b052a5] text-white px-4 py-2 rounded-lg text-[14px] font-medium transition-colors cursor-pointer"
        onClick={() => setShowModal(true)}
      >
        Add Comment
      </button>
    </div>
  );
};

export default FeedbackPopup;